import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { TagsState, RootState } from '../types';

const namespaced: boolean = true;

export const state: TagsState = {
	tags: []
};

export const Tags: Module<TagsState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default Tags;
